const experiences = [
  {
    positionName: "STARTUP DEVELOPER",
    company: "Gather",
    location: "Dallas, TX",
    start: "JAN 2024",
    end: "AUG 2024",
    desc: [
      "Collaborated cross-functionally to design and implement new features, driving 500+ downloads, having created and implemented 14 pages/wireframes in Figma & Flutter.",
      "Boosted user engagement by 43% as measured by Amazon's metrics by implementing a full app redesign and effective marketing.",
    ],
    technologies: "Flutter, Dart, Firebase, iOS Development",
    logo: "/media/utdLogo.png",
  },
  {
    positionName: "STUDENT DEVELOPER",
    company: "Kalasalingam University",
    location: "Richardson, TX",
    start: "JAN 2024",
    end: "MAY 2024",
    desc: [
      "Improved execution accuracy by ~30% with command matching using Python, optimizing speech recognition module performance and achieving strategic objectives within an agile work environment.",
      "Enhanced app efficiency using Python by saving users up to 3 seconds by implementing an ambient noise suppression mitigation algorithm.",
    ],
    technologies: "Python, Open Source Speech Recognition Module",
    logo: "/media/kalasalingamLogo.png",
  },
  {
    positionName: "STUDENT DEVELOPER",
    company: "Unlocking Doors",
    location: "Richardson, TX",
    start: "AUG 2022",
    end: "MAY 2023",
    desc: [
      "Constructed API endpoints using Prisma & JavaScript to make data requests through HTTP requests that manipulated data in PostgreSQL database.",
      "Streamlined assistance to 4,000+ clients by building tailored pages on Vue.js framework using JavaScript.",
      "Increased client satisfaction by leading 5 collaborative sessions with the front-end team and the client to assess requirements and receive feedback on the agile development process, demonstrating good interpersonal skills.",
    ],
    technologies: "JavaScript, HTML/CSS, Vue.js, PostgreSQL, Prisma",
    logo: "/media/unlockingDoorsLogo  .png",
  },
];

export default experiences;
